import angular from 'angular';
import insuranceProfilerSendReportModal from './insuranceProfilerSendReportModal';

export default angular
  .module('components.insuranceProfilerSendReportModal', [])
  .component(
    'insuranceProfilerSendReportModal',
    insuranceProfilerSendReportModal,
  ).name;
